import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

export const googleAnalytics4Script = (tracker: ConversionTracker) => {
  return `
  <script async src="https://www.googletagmanager.com/gtag/js?id=${
    tracker.tracking_pixel
  }"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${tracker.tracking_pixel}');
    gtag('set', 'user_properties', ${JSON.stringify(
      tracker.merger_keys && tracker.merger_keys.pixel_variable_merger_keys,
    )})
  </script>`;
};
